// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"501":"b75ab9c3","558":"b75ab9c3","561":"3b6b697c"}[chunkId] + ".chunk.css";
};